
import { Link } from "react-router-dom";
import teeth from "../../Images/teeth.jpg";
import teeth1 from "../../Images/teeth1.jpg";
import teeth2 from "../../Images/teeth2.jpg";
import teeth3 from "../../Images/teeth3.jpg";
import teeth4 from "../../Images/teeth4.jpg";
import teeth5 from "../../Images/teeth5.jpg";
import teeth6 from "../../Images/teeth6.jpg";
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";
import { PiWifiHighDuotone } from "react-icons/pi";





export default function Veneers() {
  return (
    <>
    <div
  className=" relative w-full min-h-[300px] sm:min-h-[400px] lg:min-h-[350px]
    bg-cover bg-[center_40%] flex items-center pt-28 sm:pt-32 "
  style={{ backgroundImage: `url(${PiWifiHighDuotone})` }}
>
  {/* Dark Overlay */}
  <div className="absolute inset-0 bg-black/55"></div>

  {/* Content */}
  <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <h1
      className=" text-white font-extrabold text-center text-3xl sm:text-2xl md:text-3xl lg:text-3xl xl:text-4xl
        leading-tight pt-5 pb-1 max-w-5xl -mt-12 sm:mt-0 mx-auto drop-shadow-[0_6px_20px_rgba(0,0,0,0.7)]" >
      Teeth Whitening - Before and After
    </h1>
  </div>
  </div>

<div className=" px-2 py-2 mt-12">
  <div className="max-w-7xl mx-auto px-6">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">

        {/* left Image */}
      <div>
        <img
          src={teeth}
          alt="Dental Consultation"
          className="w-full h-[380px] object-cover rounded-2xl"
        />
      </div>

      {/* right Content */}
      <div>
        <h1 className="text-3xl font-semibold text-[#0a0a5c] mb-3">
          Do you have embarrassing teeth that make you feel self-conscious?
        </h1>

        <p className="text-gray-700 ">
       SmileExpert can help! We offer professional teeth whitening services that may lighten your teeth by 8 shades in just one visit. Our dentists are experienced in providing safe and effective whitening treatments, so you can be sure you’re getting the best possible care. Take a look at our before and after teeth whitening pictures to see the transformation some of our patients have made.
        </p>
      </div>
</div>
  </div>
</div>

<div className="max-w-7xl mx-auto px-4 py-10">
  <h2 className="text-center text-3xl font-semibold text-[#0a0a5c] mb-8">
    Teeth Whitening - Before and After Pictures
  </h2>

  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
    {/* Item */}
    <div className="space-y-2">
      <div className="relative">
        <img
          src={teeth1}
          alt="Before"
          className="w-full h-58 object-cover rounded-lg"
        />
        
      </div>
      <div className="relative">
        <img
          src={teeth2}
          alt="After"
          className="w-full h-58 object-cover rounded-lg"
        />
        
      </div>
    </div>

    {/* Repeat same block */}
    <div className="space-y-2">
      <div className="relative">
        <img src={teeth3} alt="Teeth whitening before and after" className="w-full h-58 object-cover rounded-lg" />
        
      </div>
      <div className="relative">
        <img src={teeth4} alt="Teeth brightening results" className="w-full h-58 object-cover rounded-lg" />
        
      </div>
    </div>

    <div className="space-y-2">
      <div className="relative">
        <img src={teeth5} alt="Teeth bleaching treatment" className="w-full h-58 object-cover rounded-lg" />
        
      </div>
      <div className="relative">
        <img src={teeth6} alt="Smile enhancement procedure" className="w-full h-58 object-cover rounded-lg" />
        
      </div>
    </div>    
  </div>
</div>

<div className="max-w-7xl mx-auto px-6 py-14">
  <div className="grid grid-cols-1 md:grid-cols-2 gap-16">

    {/* LEFT COLUMN */}
    <div>
      <h1 className=" text-[#0a0a5c] font-semibold text-3xl mb-6">
        Things to Know Before You Get Teeth Whitening
      </h1>
      <p>
            Your teeth are one of the first things people notice about you. A bright, white smile can boost your confidence and make you feel more attractive. Teeth whitening is a popular way to achieve this look.<br/><br/>
            Before you get teeth whitening, there are a few things you should know.<br/>
          </p>

      <div className="space-y-6 text-sm text-gray-700 leading-relaxed">
        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            1. The teeth whitening process is simple and quick
          </h4>
          <p>
            Teeth whitening is a very brief procedure that may be done on short notice. We usually perform a comprehensive examination of your mouth before proceeding with treatment at SmileExpert. This is to ensure that your gums and teeth are in good condition and avoid any problems.
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            2. You will see results after just one treatment
          </h4>
          <p>
            The results of your teeth whitening treatment will be immediately visible. You can expect your teeth to be at least eight shades lighter after just one 45-minute session depends on diet and genetics
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            3. There are no side effects
          </h4>
          <p>
            Teeth whitening is a safe and effective way to achieve brighter teeth with no side effects. The only thing you may experience is some sensitivity during and after the treatment, but this is temporary and will go away within a day or two.
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            4. It’s affordable
          </h4>
          <p>
            Teeth whitening is an affordable way to dramatically improve your smile depending on diet, genetic and expectations. The cost of treatment depends on the severity of your tooth discoloration and the number of sessions required. 
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            5. You need to take care of your teeth afterwards
          </h4>
          <p>
           After you have Zoom teeth whitening, it’s important to take good care of your teeth to maintain the results. This means brushing twice a day, flossing daily, and avoiding foods and drinks that can stain your teeth. You should also see your dentist regularly for checkups and cleanings.<br/><br/>
           Our dentists at SmileExpert Dentistry will also ask you questions about your lifestyle and hygiene; this helps us tailor your teeth whitening treatments to you specifically. Treatment will begin if your oral health allows it.
          </p>
        </div>

        
      </div>
    </div>

    {/* RIGHT COLUMN */}
    <div>
      <h1 className=" text-[#0a0a5c] font-semibold text-3xl mb-6">
        Things to Know After You Get Teeth Whitening
      </h1>
      <p>
        Once you have gotten teeth whitening, there are a few things you should know in order to maintain your results. Here are some things to keep in mind:
      </p>

      <div className="space-y-6 text-sm text-gray-700 leading-relaxed">
        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            1. Avoid staining foods and drinks
          </h4>
          <p>
            To maintain your results, it is best to avoid food and drinks that can cause stainings, such as coffee, tea, and red wine.
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            2. Practice good oral hygiene
          </h4>
          <p>
            Be sure to brush and floss regularly and see your dentist for regular cleanings. This will help to prevent any new stains from forming on your teeth.
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            3. Touch up as needed
          </h4>
          <p>
            Teeth whitening results can last for several months, but they may start to fade over time. You can touch up your teeth whitening results as needed with at-home kits or professional treatments.
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            4. Be gentle with your teeth
          </h4>
          <p>
           Avoid using abrasive toothpaste or whitening strips that are too harsh on your teeth. This can cause sensitivity and irritation
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            5. Know when to see a dentist
          </h4>
          <p>
            If you are unsure about how to care for your teeth after whitening, or if you have any concerns, be sure to see your dentist. They can help you find the best way to care for your teeth and keep them looking their best. Contact us today to learn more or to schedule a consultation. Schedule an appointment with us today for whiter teeth!
          </p>
        </div>

        
      </div>
    </div>
  </div>
</div>

<div className="w-full h-[180px] overflow-hidden mt-4">
  <iframe
    title="clinic-map"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3445.0390050498395!2d71.9162331!3d30.292951199999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x393b557588a60575%3A0x79afa5462675bee1!2sSmile%20expert%20dental%20clinic!5e0!3m2!1sen!2s!4v1767274320473!5m2!1sen!2s"
    width="100%"
    height="450"
    style={{ border: "0" }}
    allowFullScreen
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  />
</div>

<div className="bg-[#0c2340] text-white pt-[60px] pb-[60px] px-[40px] mt-0">
  <div className="flex justify-between flex-wrap max-w-[1400px] mx-auto gap-[40px]">
    {/* COLUMN 1 */}
    <div className="min-w-[200px]">
  <h3 className="text-[20px] mb-[20px]">Useful Links</h3>

  <Link to="/about/meet-our-team" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    About Us
  </Link>

  <Link to="/contact" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Contact Us
  </Link>

  <Link to="/about/meet-our-team" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Meet the Team
  </Link>

  <Link to="/teeth-whitening-before-and-after" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Before & After
  </Link>

  <Link to="/blog" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Blogs
  </Link>
</div>


    
    <div className="min-w-[200px]">
  <h3 className="text-[20px] mb-[20px]">Treatments</h3>

  <Link to="/treatment/exam" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Exam & X-Rays Check-Up
  </Link>

  <Link to="/emergency-dentist" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Dental Emergency
  </Link>

  <Link to="/t/implants" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Smile Makeover
  </Link>

  <Link to="/t/veneer" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Veneers
  </Link>

  <Link to="/t/implants" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Dental Implants
  </Link>

  <Link to="t/canals" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Root Canal Treatment
  </Link>

  <Link to="/t/orthodontist" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Orthodontic Braces
  </Link>

  
</div>


    <div className="min-w-[200px]">
  <h3 className="text-[20px] mb-[20px]">Dental Problems</h3>

  <Link to="/yellow-teeth-treatment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Yellow Teeth
  </Link>

  <Link to="/teeth-cleaning" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Teeth Cleaning
  </Link>

  <Link to="/missing-teeth-treatment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Missing Teeth
  </Link>

  <Link to="/broken-chipped-tooth" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Broken Chipped Tooth
  </Link>

  <Link to="/gum-disease" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Gum Disease
  </Link>

  <Link to="/crooked-teeth-treatment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Crooked Teeth
  </Link>

  <Link to="/sore-teeth-treatment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Sensitive & Sore Teeth
  </Link>

  <Link to="/dental-anxiety" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Dental Anxiety
  </Link>
</div>


    <div className="min-w-[200px]">
  <h3 className="text-[20px] mb-[20px]">Patient Safety</h3>

  <Link to="/7x-safety" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    7X SAFETY
  </Link>

  <Link to="/4-step-sterilization" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    4 Step Sterilization
  </Link>

  <Link to="/safety-equipment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Safety Equipment
  </Link>

  <Link to="/equipment-technology" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Equipment & Technology
  </Link>

  <Link to="/quality" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Quality
  </Link>
</div>


    <div className="min-w-[250px]">
              <h3 className="text-[20px] mb-[20px]">Get in touch</h3>
        
              <p className="my-2 flex gap-[10px] ">📧 aneelabrar555@gmail.com</p>
        
              <p className="my-3 flex gap-[10px] ">📞 03008395562</p>
        
              <p className="my-2 flex gap-[10px] px-2">
                  <span className="">📍 Saddique Hospital Stadium Road Khanewal</span>
              </p>
        
              <p className="mt-6 font-semibold "> 🕒 Clinic Timing <br/>   <span className="ml-7">11:00am to 9:00pm</span></p>
        
              <div className="text-left bg-[#0c2340] text-white py-[50px] px-[20px]">
                <div className="flex gap-[15px] mt-[20px]">
                  <a

                      href="https://www.facebook.com/share/17zJppb7qh/"

                      target="_blank"

                      rel="noopener noreferrer"

                      className="w-[35px] h-[35px] bg-blue-900 flex justify-center items-center rounded-[8px] no-underline"

                      aria-label="Follow us on Facebook"

                    >

                      <FaFacebookF size={20} color="white" />
                  </a>
        
                  <a

        
                      href="https://instagram.com"

        
                      target="_blank"

        
                      rel="noopener noreferrer"

        
                      className="w-[35px] h-[35px] bg-[#000000] flex justify-center items-center rounded-[8px] no-underline"

        
                      aria-label="Follow us on Instagram"

        
                    >

        
                      <FaInstagram size={20} color="white" />
                  </a>
        
                  <a

        
                      href="https://youtube.com"

        
                      target="_blank"

        
                      rel="noopener noreferrer"

        
                      className="w-[35px] h-[35px] bg-[#FF0000] flex justify-center items-center rounded-[8px] no-underline"

        
                      aria-label="Subscribe to our YouTube channel"

        
                    >

        
                      <FaYoutube size={22} color="white" />
                  </a>
                </div>
              </div>
            </div>
    
  </div>
   <div className="w-full text-center justify-end mb-0 border-t border-gray-300 pt-4">
  <p className="text-sm text-gray-400">
    © SmileExpert
    <span className="mx-2 text-gray-600">|</span>
    Powered by{" "}
    <a
      href="https://verdant-soft.com/"
      target="_blank"
      rel="noopener noreferrer"
      className="text-gray-300 hover:text-blue-400 no-underline font-medium transition-colors duration-300 "
    >
      Verdant Soft
    </a>
  </p>
</div>

</div>




</>
  )
}








